<app-page-header title="CMS Content" subtitle="Manage website content pages and localization">
    <div actions class="flex gap-6">
        <p-iconfield class="w-64">
            <p-inputicon>
                <i class="pi pi-search"></i>
            </p-inputicon>
            <input pInputText type="text" (input)="applyGlobalFilter($event)" placeholder="Search keyword" />
        </p-iconfield>
        <p-button label="Clear" styleClass="p-button-outlined" (click)="dt.clear()"></p-button>
        <p-button label="CREATE NEW" icon="pi pi-plus" styleClass="p-button-primary" (click)="createNew()"></p-button>
    </div>
</app-page-header>

<div class="table-card">
    <p-table
        #dt
        dataKey="id"
        [value]="pages"
        [rows]="10"
        [rowsPerPageOptions]="[10, 25, 50, 100]"
        [loading]="loading"
        [paginator]="true"
        [globalFilterFields]="[
            'id',
            'titles',
            'urls',
            'category.name',
            'locales',
            'createdAt',
            'createdBy',
            'updatedBy',
            'createdAtDateOnly',
            'updatedAtDateOnly'
        ]"
        [rowHover]="true"
        [(selection)]="selectedPages"
        [scrollable]="true"
        sortField="updatedAt"
        [sortOrder]="-1"
    >
        <ng-template pTemplate="header">
            <tr>
                <th>Title</th>
                <th pSortableColumn="category.name">Category <p-sortIcon field="category.name"></p-sortIcon></th>
                <th pSortableColumn="language" style="min-width: 10rem">Languages <p-sortIcon field="language"></p-sortIcon></th>
                <th pSortableColumn="createdAt">Created Date <p-sortIcon field="createdAt"></p-sortIcon></th>
                <th pSortableColumn="createdBy">Created By <p-sortIcon field="createdBy"></p-sortIcon></th>
                <th pSortableColumn="updatedAt">Updated Date <p-sortIcon field="updatedAt"></p-sortIcon></th>
                <th pSortableColumn="updatedBy">Updated By <p-sortIcon field="updatedBy"></p-sortIcon></th>
                <th alignFrozen="right" pFrozenColumn [frozen]="true">Actions</th>
            </tr>
            <tr>
                <th>
                    <input pInputText type="text" placeholder="Search by title" class="w-full" (input)="applyTitleFilter($event)" />
                </th>
                <th>
                    <p-columnFilter
                        [showMenu]="false"
                        [hideOnClear]="true"
                        type="text"
                        field="category.name"
                        placeholder="Search by category"
                        ariaLabel="Filter Category"
                    >
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <input
                                pInputText
                                type="text"
                                [ngModel]="value"
                                (ngModelChange)="filter($event)"
                                placeholder="Search by category"
                            />
                        </ng-template>
                    </p-columnFilter>
                </th>
                <th>
                    <p-columnFilter
                        [showMenu]="false"
                        [hideOnClear]="true"
                        type="text"
                        field="locales"
                        placeholder="Search by language locale"
                        ariaLabel="Filter Language Locale"
                    >
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <input
                                pInputText
                                type="text"
                                [ngModel]="value"
                                (ngModelChange)="filter($event)"
                                placeholder="Search by language"
                            />
                        </ng-template>
                    </p-columnFilter>
                </th>
                <th>
                    <p-columnFilter
                        [showMenu]="false"
                        [hideOnClear]="true"
                        type="date"
                        field="createdAt"
                        placeholder="Search by created date"
                        ariaLabel="Filter Created Date"
                    >
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <input pInputText type="date" [ngModel]="value" (ngModelChange)="filterByDate($event, 'createdAtDateOnly')" />
                        </ng-template>
                    </p-columnFilter>
                </th>
                <th>
                    <p-columnFilter
                        [showMenu]="false"
                        [hideOnClear]="true"
                        type="text"
                        field="createdBy"
                        placeholder="Search by created by"
                        ariaLabel="Filter Created By"
                    >
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <input
                                pInputText
                                type="text"
                                [ngModel]="value"
                                (ngModelChange)="filter($event)"
                                placeholder="Search by created by"
                            />
                        </ng-template>
                    </p-columnFilter>
                </th>
                <th>
                    <p-columnFilter
                        [showMenu]="false"
                        [hideOnClear]="true"
                        type="date"
                        field="updatedAt"
                        placeholder="Search by updated date"
                        ariaLabel="Filter Updated Date"
                    >
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <input pInputText type="date" [ngModel]="value" (ngModelChange)="filterByDate($event, 'updatedAtDateOnly')" />
                        </ng-template>
                    </p-columnFilter>
                </th>
                <th>
                    <p-columnFilter
                        [showMenu]="false"
                        [hideOnClear]="true"
                        type="text"
                        field="updatedBy"
                        placeholder="Search by updated by"
                        ariaLabel="Filter Updated By"
                    >
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <input
                                pInputText
                                type="text"
                                [ngModel]="value"
                                (ngModelChange)="filter($event)"
                                placeholder="Search by updated by"
                            />
                        </ng-template>
                    </p-columnFilter>
                </th>

                <th alignFrozen="right" pFrozenColumn [frozen]="true"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-page>
            <tr>
                <td class="!p-2">
                    <div class="font-semibold">{{ getTitle(page) }}</div>
                </td>
                <td>{{ page.category.name }}</td>
                <td>
                    <div class="flex flex-col">
                        <div *ngFor="let language of page.localizedPageContents" class="flex items-center gap-2">
                            <p-tag [severity]="getLanguageSeverity(language.active)" styleClass="cms-lang-tag">
                                <span class="whitespace-nowrap">{{ language.language.locale }}</span>
                            </p-tag>
                            <a
                                *ngIf="language.absoluteUrl"
                                [href]="language.absoluteUrl"
                                target="_blank"
                                class="text-sm text-gray-500 whitespace-nowrap"
                            >
                                {{ language.url }} <i class="pi pi-external-link"></i>
                            </a>
                            <span *ngIf="!language.absoluteUrl" class="text-sm text-gray-500 whitespace-nowrap">{{ language.url }}</span>
                        </div>
                    </div>
                </td>
                <td>{{ page.createdAt | date: 'dd-MM-yyyy HH:mm' }}</td>
                <td>{{ page.createdBy }}</td>
                <td>{{ page.updatedAt | date: 'dd-MM-yyyy HH:mm' }}</td>
                <td>{{ page.updatedBy }}</td>
                <td alignFrozen="right" pFrozenColumn [frozen]="true">
                    <div class="flex justify-center gap-2">
                        <button class="p-button-rounded p-button-text p-button-sm" (click)="editPage(page)">
                            <i class="pi pi-pencil text-blue-500"></i>
                        </button>
                        @if (showDeleteAction) {
                            <button class="p-button-rounded p-button-text p-button-sm" (click)="deletePage($event, page)">
                                <i class="pi pi-trash text-red-500"></i>
                            </button>
                        }
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="8" class="text-center p-4">No pages found.</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft">
            <div class="text-sm text-gray-500">
                Showing {{ pages.length ? 1 : 0 }} to {{ pages.length > 10 ? 10 : pages.length }} of {{ totalRecords }} entries
            </div>
        </ng-template>
    </p-table>
</div>

<p-toast></p-toast>
<p-confirmpopup></p-confirmpopup>
